const state = {
  uploadImg: '/api/file/upload',
  sellerTypeList: [
    {txt: '长期商户', val: 1},
    {txt: '临时商户', val: 2},
    {txt: '外仓商户', val: 4}
  ],
  sellerStatusList: [
    {txt: '全部', val:''},
    // {txt: '未启用', val: 1},
    {txt: '启用', val: 2},
    {txt: '禁用', val: 3}
  ],
  approveStatusList: [
    {txt: '全部', val: ''},
    {txt: '待审核', val: 1},
    {txt: '通过', val: 2},
    {txt: '驳回', val: 3}
  ],
  approveTypeList: [
    {txt: '全部', val: ''},
    {txt: '商户新增', val: 1},
    {txt: '商户修改', val: 2},
    {txt: '子商户新增', val: 3},
    {txt: '子商户修改', val: 4},
    {txt: '关联商户', val: 5}
  ],

}
const mutations = {

  SET_SIZE: (state, size) => {
    state.size = size
    localStorage.setItem('size', size)
  }
}
const actions = {
  setSize({commit}, size) {
    commit('SET_SIZE', size)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/seller.js